//-------------------------- save  -------------------------- //

window.stepSave = {}

stepSave.stepZip = async function (stepSelected) {
    const zip_code = steps[stepSelected].querySelector('#zip_code').value

    setCookie('form_zip_code', zip_code)
}

//-------------------------- verification  -------------------------- //

window.stepCheck = {}

stepCheck.stepZip = async function (stepSelected, with_error, with_target, is_step_handle) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'zip_code') {
        const zip_code = stepElement.querySelector('#zip_code')

        if (zip_code.value.length !== 5 || zip_code.value === '00000') {
            error = true

            toggleInputError(zip_code, stepElement, false, with_error)
        } else {
            if (with_target == null) {
                const zipData = await getZipData(zip_code.value)

                document.querySelector('#zip_country').value = zipData['country'] ?? ''
                document.querySelector('#zip_state').value = zipData['state'] ?? ''
                document.querySelector('#zip_city').value = zipData['city'] ?? ''

                if (zipData['city'] === '' || zipData['city'] === 'undefined') {
                    error = true

                    toggleInputError(zip_code, stepElement, false, with_error)
                } else {
                    //special trigger for autofill scenario
                    const stepData = getStepDataByID('stepAddress')

                    if (stepData.stepKey) {
                        stepCheck.stepAddress(stepData.stepKey, true)
                    }

                    toggleInputError(zip_code, stepElement, true, with_error)
                }
            } else {
                toggleInputError(zip_code, stepElement, true, with_error)
            }
        }
    }

    return error
}

stepCheck.stepContact = async function (stepSelected, with_error, with_target) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'first_name') {
        const first_name = stepElement.querySelector('#first_name')

        if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
            error = true

            toggleInputError(first_name, stepElement, false, with_error)
        } else {
            toggleInputError(first_name, stepElement, true, with_error)
        }
    }

    if (with_target == null || with_target === 'last_name') {
        const last_name = stepElement.querySelector('#last_name')

        if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
            error = true

            toggleInputError(last_name, stepElement, false, with_error)
        } else {
            toggleInputError(last_name, stepElement, true, with_error)
        }
    }

    return error
}

stepCheck.stepAddress = function (stepSelected, with_error) {
    const stepElement = steps[stepSelected]
    let error = false

    const address = stepElement.querySelector('#address')

    if (address.value.length === 0) {
        error = true
    } else {
        if (hasAddressDetails() === false) {
            error = true
        }
    }

    toggleInputError(address, stepElement, !error, with_error)

    return error
}

stepCheck.stepEmailPhone = async function (stepSelected, with_error, with_target, is_step_handle) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'phone') {
        const phone = stepElement.querySelector('#phone')

        if (isPhone(phone.value) === false) {
            error = true

            toggleInputError(phone, stepElement, false, with_error)
        } else {
            if (is_step_handle === true) { //do phone verification only when button is clicked
                toggleLoading(phone, true)

                let is_valid = await twilioVerify(phone.value)

                toggleLoading(phone, false)

                if (is_valid === true) {
                    toggleInputError(phone, stepElement, true, with_error)
                } else {
                    error = true

                    toggleInputError(phone, stepElement, false, with_error)
                }
            } else {
                toggleInputError(phone, stepElement, true, with_error)
            }
        }
    }

    if (with_target == null || with_target === 'email_address') {
        const email_address = stepElement.querySelector('#email_address')

        if (isEmailAddress(email_address.value) === false) {
            error = true

            toggleInputError(email_address, stepElement, false, with_error)
        } else {
            toggleInputError(email_address, stepElement, true, with_error)
        }
    }

    return error
}

//-------------------------- binds  -------------------------- //

window.setupBind = {}

setupBind.stepZip = function (stepElement, stepKey) {
    let inputZipCode = stepElement.querySelector('#zip_code')

    inputZipCode.addEventListener('keyup', async (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        event.target.value = event.target.value.slice(0, 5)

        let is_disabled = await stepCheck.stepZip(stepKey, false, 'zip_code')

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputZipCode.addEventListener('change', async () => {
        let is_disabled = await stepCheck.stepZip(stepKey, false, 'zip_code')

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

setupBind.stepContact = function (stepElement, stepKey) {
    let idsContact = ['first_name', 'last_name']

    //first_name
    let inputFirstName = stepElement.querySelector('#first_name')

    inputFirstName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepContact(stepKey, false, 'first_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputFirstName.addEventListener('change', () => {
        stepCheck.stepContact(stepKey, false, 'first_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    //last_name
    let inputLastName = stepElement.querySelector('#last_name')

    inputLastName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepContact(stepKey, false, 'last_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputLastName.addEventListener('change', () => {
        stepCheck.stepContact(stepKey, false, 'last_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

setupBind.stepAddress = function (stepElement, stepKey) {
    let inputAddress = stepElement.querySelector('#address')

    inputAddress.addEventListener('keydown', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        resetAddressComponent()

        let is_disabled = stepCheck.stepAddress(stepKey, false)

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputAddress.addEventListener('change', () => {
        let is_disabled = stepCheck.stepAddress(stepKey, false)

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

setupBind.stepEmailPhone = function (stepElement, stepKey) {
    let idsEmailPhone = ['phone', 'email_address']

    //phone
    let inputPhoneHome = stepElement.querySelector('#phone')

    inputPhoneHome.addEventListener('keydown', async (event) => {
        if (!upKeyCodePhone(event)) {
            event.preventDefault()
        }
    })

    inputPhoneHome.addEventListener('keyup', async (event) => {
        if (formatKeyCodePhone(event)) {
            formatToPhone(event)

            await stepCheck.stepEmailPhone(stepKey, false, 'phone')

            let is_disabled = stepInputValid(idsEmailPhone) !== true

            stepNextButtonStatus(stepKey, is_disabled)
        }
    })

    inputPhoneHome.addEventListener('change', async (event) => {
        formatToPhone(event)

        await stepCheck.stepEmailPhone(stepKey, false, 'phone')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    //email
    let inputEmailAddress = stepElement.querySelector('#email_address')

    inputEmailAddress.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepEmailPhone(stepKey, false, 'email_address')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputEmailAddress.addEventListener('change', () => {
        stepCheck.stepEmailPhone(stepKey, false, 'email_address')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

//-------------------------- form  -------------------------- //

stepShowRules = function (stepSelected) {
    return stepSelected
}

stepShowSetup = function (stepSelected) {
    //show tcpa info
    if (steps[stepSelected].id === options.stepFinal) {
        document.querySelector('.tcpa-info').style.display = 'block'
    } else {
        document.querySelector('.tcpa-info').style.display = 'none'
    }

    //hide elements depending on form step
    if (steps[stepSelected].id !== options.stepFirst) {
        toggleElementsBasedOnFormStep(true)
    }

    let formContentElement = document.querySelector('#form-container .form-content')

    formContentElement.className = 'box form-content'
    formContentElement.classList.add(steps[stepSelected].id)
}

toggleElementsBasedOnFormStep = function(is_hidden) {
    const hideElements = document.querySelectorAll('.form-hide')

    for (const hideElement of hideElements) {
        if (is_hidden === true) {
            hideElement.classList.add('hidden-on')
        } else {
            hideElement.classList.remove('hidden-on')
        }
    }
}

stepNextButtonAppend = function(stepElement, p) {
    stepElement.appendChild(p)
}

calcStepProgress = function (stepID) {
    let inputValid = 0
    let inputCount = 1

    switch (stepID) {
        case 'stepZip':
            const inputZip = document.querySelector('#zip_code')

            if (inputZip.classList.contains('is-valid')) {
                inputValid += 1
            }
            break;
        case 'stepAddress':
            const inputAddress = document.querySelector('#address')

            if (inputAddress.classList.contains('is-valid')) {
                inputValid += 1
            }
            break;
        case 'stepContact':
            inputCount = 2

            //first_name
            const inputFirstName = document.querySelector('#first_name')

            if (inputFirstName.classList.contains('is-valid')) {
                inputValid += 1
            }

            //last_name
            const inputLastName = document.querySelector('#last_name')

            if (inputLastName.classList.contains('is-valid')) {
                inputValid += 1
            }
            break;
        case 'stepEmail':
            const inputEmailAddress = document.querySelector('#email_address')

            if (inputEmailAddress.classList.contains('is-valid')) {
                inputValid += 1
            }
            break;
        case 'stepPhone':
            const inputPhone = document.querySelector('#phone')

            if (inputPhone !== null && inputPhone.classList.contains('is-valid')) {
                inputValid += 1
            }
            break;
        default:
            break;
    }

    return inputValid / inputCount
}

submitHandle = function (button) {
    const form = button.form
    const formData = new FormData(form)

    switch (options.formSubmit) {
        default:
            window.history.pushState({}, null, options.resultsURL)

            toggleElementsBasedOnFormStep(false) //add header & footer elements back

            stepNextButtonLoading(button, false) //this actually disable overlay

            if (typeof options.submitCallback !== 'undefined' && typeof options.submitCallback === 'function') {
                options.submitCallback(formData)
            }

            //process
            fetch(options.processURL, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            })

            if (mdrvConfigData.environment === 'production' &&typeof options.formSource !== 'undefined') {
                switch (options.formSource) {
                    case 'medicare-solutions':
                    case 'medicare-solutions-1':
                        loadScript(mdrvConfigData.everflow.script, () => {
                            console.log('EF.conversion')

                            EF.conversion({
                                offer_id: 8107,
                            })
                        })
                        break;
                    case 'life-insurance':
                    case 'life-insurance-1':
                    case 'life-insurance-2':
                    case 'life-insurance-3':
                    case 'life-insurance-4':
                    case 'life-insurance-cta1':
                        loadScript(mdrvConfigData.everflow.script, () => {
                            console.log('EF.conversion')

                            EF.conversion({
                                offer_id: 8208,
                            })

                            EF.conversion({
                                aid: 2370,
                            })
                        })
                        break;
                    case 'term-life-insurance':
                    case 'universal-life-insurance':
                    case 'whole-life-insurance':
                    case 'mortgage-protection-insurance':
                        loadScript(mdrvConfigData.everflow.script, () => {
                            // console.log('EF.conversion')

                            EF.conversion({
                                aid: 2370,
                            })
                        })
                        break;
                    // moved to back-end -> API
                    // case 'disability-income-insurance':
                    //     loadScript(mdrvConfigData.everflow.script, () => {
                    //         console.log('EF.conversion')
                    //
                    //         EF.conversion({
                    //             offer_id: 8418,
                    //         })
                    //     })
                    //     break;
                }
            }

            if (mdrvConfigData.environment === 'production') {
                googleTriggerEvent('LeadFormSubmit')
            }
            break;
    }
}
